import angular from 'angular';

import component from './offlineModeSelector.component';

// Dependencies
import logServiceModule from '../../service/LogService';
import translationServiceModule from '../../service/TranslationService';
import confirmModalModule from '../modals/confirmModal';
import uiBootstrapDropdownModuleName from 'angular-ui-bootstrap/src/dropdown'


let module = angular.module('recaps.components.offlineModeSelector', [
  logServiceModule.name,
  translationServiceModule.name,
  confirmModalModule.name,
  uiBootstrapDropdownModuleName,
]);

module.component('offlineModeSelector', component);

export default module;
